import Checkbox from './src/JsmCheckbox.vue'

Checkbox.install = (Vue) => {
  Vue.component(Checkbox.name, Checkbox)
}

export default Checkbox
